// adminApi.js - Fix the import
import api from './axios'; // ✅ Use './axios' since that's your file name

// User Management
export const getUsers = async (filters = {}) => {
  const params = new URLSearchParams();
  
  // Build query parameters from filters
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      params.append(key, value);
    }
  });

  const response = await api.get(`/api/admin/users?${params.toString()}`);
  return response.data;
};

export const getUserById = async (userId) => {
  const response = await api.get(`/api/admin/users/${userId}`);
  return response.data;
};

export const getAllUsers = async () => {
  try {
    const response = await api.get('/api/auth/GetAllUsers');
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Lightweight user lookup (id + name only).
 * Use this instead of getAllUsers for assignment dropdowns / display.
 */
export const getUserLookup = async () => {
  try {
    const response = await api.get('/api/auth/lookup');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getPendingApprovals = async () => {
  const response = await api.get('/api/admin/users/pending');
  return response.data;
};

export const getUserStats = async () => {
  const response = await api.get('/api/admin/users/stats');
  return response.data;
};

export const getEmployees = async () => {
  const response = await api.get('/api/admin/employees');
  return response.data;
};

export const getLeads = async () => {
  const response = await api.get('/api/admin/leads');
  return response.data;
};

export const getUsersByRole = async (role) => {
  const response = await api.get(`/api/admin/users/by-role/${role}`);
  return response.data;
};

export const getAvailableTeamMembers = async () => {
  const response = await api.get('/api/admin/users/available-team-members');
  return response.data;
};

// Approval Workflow
export const approveUser = async (request) => {
  const response = await api.post('/api/admin/users/approve', request);
  return response.data;
};

export const rejectUser = async (request) => {
  const response = await api.post('/api/admin/users/reject', request);
  return response.data;
};

// Role Management
export const updateUserRole = async (request) => {
  const response = await api.put('/api/admin/users/role', request);
  return response.data;
};

export const assignSapId = async (request) => {
  const response = await api.post('/api/admin/users/assign-sap-id', request);
  return response.data;
};

export const removeSapId = async (userId) => {
  const response = await api.delete(`/api/admin/users/${userId}/sap-id`);
  return response.data;
};

// User Update
export const updateUser = async (userId, userData) => {
  const response = await api.put(`/api/auth/${userId}`, userData);
  return response.data;
};

// Utility
export const getRoles = async () => {
  const response = await api.get('/api/admin/roles');
  return response.data;
};

export const getDepartments = async () => {
  const response = await api.get('/api/admin/departments');
  return response.data;
};

// Enums for frontend use
export const UserRole = {
  User: 0,
  Employee: 1,
  Lead: 2,
  PM: 3,
  Admin: 4
};

export const ApprovalStatus = {
  Pending: 0,
  Approved: 1,
  Rejected: 2
};

export const getRoleName = (role) => {
  const names = ['User', 'Employee', 'Lead', 'PM', 'Admin'];
  return names[role] || 'Unknown';
};

export const getApprovalStatusName = (status) => {
  const names = ['Pending', 'Approved', 'Rejected'];
  return names[status] || 'Unknown';
};

export const getRoleBadgeColor = (role) => {
  const colors = {
    0: 'bg-gray-100 text-gray-800',
    1: 'bg-blue-100 text-blue-800',
    2: 'bg-purple-100 text-purple-800',
    3: 'bg-indigo-100 text-indigo-800',
    4: 'bg-red-100 text-red-800'
  };
  return colors[role] || 'bg-gray-100 text-gray-800';
};

export const getApprovalStatusBadgeColor = (status) => {
  const colors = {
    0: 'bg-yellow-100 text-yellow-800',
    1: 'bg-green-100 text-green-800',
    2: 'bg-red-100 text-red-800'
  };
  return colors[status] || 'bg-gray-100 text-gray-800';
};

/* ───── AI Insight Email Settings ───── */

export const getAiInsightEmailSettings = async () => {
  const response = await api.get('/api/admin/ai-insight-emails');
  return response.data;
};

export const createAiInsightEmailSetting = async (setting) => {
  const response = await api.post('/api/admin/ai-insight-emails', setting);
  return response.data;
};

export const updateAiInsightEmailSetting = async (id, setting) => {
  const response = await api.put(`/api/admin/ai-insight-emails/${id}`, setting);
  return response.data;
};

export const deleteAiInsightEmailSetting = async (id) => {
  const response = await api.delete(`/api/admin/ai-insight-emails/${id}`);
  return response.data;
};

export const toggleAiInsightEmailSetting = async (id) => {
  const response = await api.post(`/api/admin/ai-insight-emails/${id}/toggle`);
  return response.data;
};

export const sendTestAiInsightEmail = async (id) => {
  const response = await api.post(`/api/admin/ai-insight-emails/${id}/send-test`);
  return response.data;
};